/* eslint-disable import/prefer-default-export */

// ─── Kolom tabel produk (dipakai di DetailOrder.vue) ───
export const columns = [
  {
    key: 'no',
    label: 'No',
    tdClass: 'text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    tdClass: 'text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'price',
    label: 'Harga Satuan',
    tdClass: 'text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'qty',
    label: 'Jumlah',
    tdClass: 'text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'subtotal',
    label: 'Sub Total',
    tdClass: 'text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
]

// ─── Kolom tabel hasil pencarian bulk (dipakai di List.vue) ───
const TH_BASE = {
  textTransform: 'capitalize',
  fontSize: '14px',
  color: 'black',
  whiteSpace: 'nowrap',
}

export const searchTableColumns = [
  {
    key: 'order_date',
    label: 'Tanggal Order',
    thStyle: { ...TH_BASE, minWidth: '230px' },
    tdClass: 'text-black align-middle',
  },
  {
    key: 'customer_name',
    label: 'Pelanggan',
    thStyle: { ...TH_BASE, minWidth: '250px' },
    tdClass: 'align-middle',
  },
  {
    key: 'grandtotal',
    label: 'Total Pembayaran',
    thStyle: { ...TH_BASE, minWidth: '200px' },
    tdClass: 'align-middle',
  },
  {
    key: 'airway_bill',
    label: 'No Resi',
    thStyle: { ...TH_BASE, minWidth: '250px' },
    tdClass: 'align-middle',
  },
  {
    key: 'order_status',
    label: 'Status Order',
    thStyle: { ...TH_BASE, minWidth: '200px' },
    tdClass: 'align-middle',
  },
  {
    key: 'detail',
    label: 'Detail',
    thStyle: { ...TH_BASE, whiteSpace: 'normal', minWidth: '200px' },
    tdClass: 'align-middle',
  },
]

// ─── Opsi dropdown tipe pencarian ───
export const searchTypeOptions = [
  { value: 'resi', text: 'Nomor Resi' },
  { value: 'order_no', text: 'Nomor Order' },
]

// ─── Map status order → variant badge Bootstrap ───
export const STATUS_VARIANT_MAP = {
  Diajukan: 'primary',
  Dipacking: 'info',
  Dikirim: 'warning',
  Diterima: 'success',
  Retur: 'danger',
  Batal: 'dark',
  Hilang: 'danger',
  Rusak: 'danger',
}

// ─── Map status order → label yang lebih human-friendly ───
export const STATUS_LABEL_MAP = {
  Diajukan: 'Order Dibuat',
  Batal: 'Order Dibatalkan',
  Hilang: 'Paket Hilang',
  Rusak: 'Paket Rusak',
}
